var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DownloadInvoice"},[_c('button',{staticClass:"DownloadInvoice__button btn btn-xs button",attrs:{"id":"js-test__download"},on:{"click":_vm.downloadFile}},[_c('i',{staticClass:"fa fa-file-pdf-o DownloadInvoice__button--icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"DownloadInvoice__button--text"},[_vm._v("Pobierz")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56ec953b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/DownloadInvoice/index.vue
// module id = 1214
// module chunks = 0 5